import React from 'react';
import { useTranslation } from 'react-i18next';

interface FallbackProps {
  children?: React.ReactNode;
  message: string;
  verticalPadding?: number;
  horizontalPadding?: string;
}

export function ContactsFallbackComponent ({
  message, children: icon, verticalPadding, horizontalPadding
}: FallbackProps): React.JSX.Element {
  const { t } = useTranslation();
    
  return (
    <section data-qa-id="contact-not-found" className={`grid justify-center p-2 bg-background rounded-md 
    ${(verticalPadding !== undefined) ? `py-${verticalPadding}` : 'py-4'} 
    ${(horizontalPadding !== undefined) ? `px-${horizontalPadding}` : 'w-full'}`}>
      <header className='flex justify-center'>
        {icon}
      </header>
      <p className="text-center text-gray-500 text-md font-bolder py-4">{t(message)}</p>
    </section>
  );
}